
      // Add preconnect and dns-prefetch dynamically based on environment
      const apiBaseUrl = import.meta.env.VITE_DIVEPEAKS_API_BASE_URL;
      if (apiBaseUrl) {
        try {
          const url = new URL(apiBaseUrl);
          const origin = url.origin;

          // Add preconnect link
          const preconnect = document.createElement('link');
          preconnect.rel = 'preconnect';
          preconnect.href = origin;
          preconnect.crossOrigin = 'anonymous';
          document.head.appendChild(preconnect);

          // Add dns-prefetch link
          const dnsPrefetch = document.createElement('link');
          dnsPrefetch.rel = 'dns-prefetch';
          dnsPrefetch.href = origin;
          document.head.appendChild(dnsPrefetch);

        } catch (e) {
          console.warn('Failed to add preconnect links:', e);
        }
      }
    